import { BackgroundColors } from '@picsart/design-system/foundation/colors';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {},
    banner: {
      display: 'grid',
      gridTemplateRows: '1fr',
      gridTemplateColumns: '6fr 6fr',
      gridTemplateAreas: "'media content'",
      gridGap: Spacings.s72,

      '&.reversed': {
        gridTemplateAreas: "'content media'",
      },

      [mediaQuery(1023)]: {
        gridGap: Spacings.s24,
      },
      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '&, &.reversed': {
          gridTemplateColumns: '1fr',
          gridTemplateAreas: "'media' 'content'",
          gridGap: Spacings.s0,
        },
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        margin: [Spacings.s0, 'auto'],
        gap: Spacings.s0,
        maxWidth: 456,
      },
    },
    titleFallback: {
      height: 48,
      width: '100%',
      marginBottom: Spacings.s8,

      [mediaQuery(1365)]: {
        height: 36,
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        height: 28,
      },
    },

    contentWrapper: {
      gridArea: 'content',
    },
    featureFallback: {
      position: 'relative',
      height: 110,
      boxShadow: `${Spacings.s0} ${Spacings.s0} ${Spacings.s16} ${BackgroundColors.tint2}`,
      borderRadius: CornerRadius.r8,
      margin: [Spacings.s0, Spacings.s0, Spacings.s8, Spacings.s0],
      padding: [Spacings.s24, Spacings.s72, Spacings.s24, Spacings.s40],

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        minHeight: 'auto',
      },
    },

    mediaWrapper: {
      gridArea: 'media',
    },
    mediaContainerFallback: {
      width: 622,
      height: 622,
      padding: [Spacings.s24, Spacings.s0, Spacings.s12],
    },
    buttonFallback: {
      marginTop: Spacings.s24,
      width: 200,
      height: 50,
    },
  }),
  {
    name: 'image-and-cta-features',
  },
);

export default useStyles;
